import { ApolloProvider as BaseApolloProvider } from '@apollo/client';
import { ConfigProvider as RHHCConfigProvider } from '@city-of-helsinki/react-helsinki-headless-cms';
import {
  ApolloErrorNotification,
  useApolloErrorHandler,
} from '@events-helsinki/components';
import React from 'react';
import useSportsRHHCConfig from '../../hooks/useSportsRHHCConfig';
import { useSportsApolloClient } from '../clients/sportsApolloClient';

export type Props = Readonly<{
  children: React.ReactNode;
}>;

function SportsApolloProvider({ children }: Props) {
  const { showErrorNotification, handleError, onCloseErrorHandler } =
    useApolloErrorHandler();
  const apolloClient = useSportsApolloClient({ handleError });
  const rhhcConfig = useSportsRHHCConfig({ apolloClient });

  return (
    <BaseApolloProvider client={apolloClient}>
      <RHHCConfigProvider config={rhhcConfig}>{children}</RHHCConfigProvider>
      {showErrorNotification && (
        <ApolloErrorNotification onClose={onCloseErrorHandler} />
      )}
    </BaseApolloProvider>
  );
}

export default SportsApolloProvider;
